'use strict'
/**
 * todayResponse.js — Contrato TodayResponse (MACRO 1 · Ola 2 · el último
 * a propósito: el más gordo, 34 keys top-level, el más acoplado).
 *
 * PRODUCTOR: server.js · GET /api/today (res.json @ ~L4986)
 * CONSUMIDOR: TodayV2Page (vía useToday / fetch directo)
 *
 * Tipado por capas de dureza:
 *   - DURO: lo que la UI rompe si falta (date, day_plan, hero_state, streak…)
 *   - NULLABLE: lo que legítimamente puede no existir (reasoning, prime_adapt…)
 *   - PASSTHROUGH: extensiones futuras no rompen el contrato
 */

const { z } = require('./z')
const { DayPlanSchema } = require('./dayPlan')

const TodayResponseSchema = z
  .object({
    // ── Núcleo duro ─────────────────────────────────────────────────────
    date: z.string(),
    user: z.unknown(),
    hero_state: z.unknown(),
    day_plan: DayPlanSchema.nullable(),
    aria_message: z.string().nullable(),
    streak: z.number(),
    week_number: z.number(),
    sessions_completed_this_plan: z.number(),
    sessions_total_plan: z.number(),
    week_progress: z.unknown(),

    // ── Contexto del día ────────────────────────────────────────────────
    chronotype_tip: z.unknown().nullable().optional(),
    wearable_mode: z.unknown().optional(),
    wearable_signals: z.unknown().optional(),
    injury_status: z.unknown().nullable().optional(),
    domains: z.unknown().optional(),

    // ── Capa 1 TODAY: línea de vida ─────────────────────────────────────
    user_started_at: z.string().nullable(),
    profile: z
      .object({
        goal_target_date: z.string().nullable(),
        goal_subtype: z.string().nullable(),
        primary_goal: z.string().nullable(),
      })
      .passthrough(),
    plan_phases: z.unknown().nullable().optional(),

    // ── Reasoning del motor (porqué) ────────────────────────────────────
    reasoning: z.unknown().nullable(),
    reasoning_gaps: z.unknown().nullable(),
    reasoning_coverage_pct: z.number().nullable(),
    nutrition_summary_line: z.string().nullable().optional(),

    // ── PRIME ADAPT / TRUTH (honestidad #10) ────────────────────────────
    prime_adapt: z.unknown().nullable(),
    prime_truth: z.unknown().nullable(),
    calibration_status: z.string(),
    kb_refs: z.array(z.unknown()),
    plate2_load: z.unknown().nullable().optional(),
    plate_active: z.boolean().optional(),
    vital_load: z.number().nullable(),
    blueprint_phase: z.unknown().nullable().optional(),
    block_number: z.number().nullable().optional(),
    is_enriched: z.boolean(),

    // ── Coherencia vertical A3/A8 ───────────────────────────────────────
    limiting_domain: z.string().nullable(),
    adapt_signal_hub: z.unknown().nullable().optional(),
    // MOTOR SIGNALS: prime score del momento + historial para Línea de Vida it.2
    prime_today: z
      .object({ value: z.number(), delta: z.number().nullable() })
      .nullable()
      .optional(),
    path_history: z
      .array(z.object({ date: z.string(), value: z.number() }))
      .optional(),
  })
  .passthrough()

module.exports = { TodayResponseSchema }
